<app-leveling-screen 
        [App]="appEnum.BrainGame"
        [Game]="game"
        [score]="score"
        [phaser]="phaser"
        (extraClicked)="showLeaderboard()"
        (doneClicked)="done()"
        (retryClicked)="retry()"></app-leveling-screen>